import styled from 'styled-components';

const StyledToolTipForTable = styled.div`
	span.motif-tooltip-wrapper {
		cursor: pointer;
	}
	span.motif-tooltip-wrapper,
	span.motif-tooltip-trigger-wrap {
		margin-left: 0 !important;
	}
`;

export default StyledToolTipForTable;
